import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, FormFieldComponentProps, VerificationServiceProps, Country } from '../../../lib/types/types';
import { TypeaheadComponent } from '../../FormInputs/Typeahead/TypeaheadComponent';
import { getSafe } from '../../../lib/utils/objects';

const TeacherSchoolComponent = ({
    value,
    isErrored,
    onChange,
    verificationService,
    placeholder = '',
}: FormFieldComponentProps & VerificationServiceProps) => {
    const programId = verificationService.programId;

    return (
        <div className="sid-field sid-teacher-school-id">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-teacher-school">
                <div className="sid-field__label sid-field__label--required sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="schoolName"
                        defaultMessage="School name"
                    />
                </div>
            </label>
            <TypeaheadComponent
                className={isErrored ? 'sid-text-input--error' : ''}
                countryCode={getSafe<Country>(() => verificationService.viewModel.countryChoice.value)}
                onChange={ (choice: FormSelectChoice) => onChange(choice) }
                minimumSearchValueLength={3}
                placeholder={placeholder}
                programId={programId}
                value={value}
                inputHtmlId="sid-teacher-school"
                openOrgSearchEnabled={verificationService.programTheme.openOrgSearchEnabled}
                orgSearchUrl={verificationService.programTheme.config.orgSearchUrl}
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidOrganization"
                            defaultMessage="You must select an organization from the list"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export {  TeacherSchoolComponent };
